import { render } from "./PantryImageRoomItem.vue?vue&type=template&id=2113af57&ts=true"
import script from "./PantryImageRoomItem.vue?vue&type=script&lang=ts"
export * from "./PantryImageRoomItem.vue?vue&type=script&lang=ts"

import "./PantryImageRoomItem.vue?vue&type=style&index=0&id=2113af57&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__